import { ReactElement } from 'react'
import { WarningAmber } from '@mui/icons-material'
import TooltipIcon from '@ui/feedback/TooltipIcon'

interface DecimalScaleWarningIndicatorProps {
  decimalScale: number
}

const DecimalScaleWarningIndicator = ({
  decimalScale,
}: DecimalScaleWarningIndicatorProps): ReactElement => (
  <TooltipIcon
    title={`Koordinate liegt außerhalb des eingestellten Rasters von ${decimalScale} Dezimalstellen`}
    placement="top"
    icon={<WarningAmber sx={{ color: 'info.main', padding: 0, fontSize: 'inherit' }} />}
  />
)

export default DecimalScaleWarningIndicator
